export enum Tags {
  Paragraph = 'p',
  Span = 'span',
  Heading = 'h1',
  Heading_2 = 'h2',
  Heading_3 = 'h3',
  Heading_4 = 'h4',
  Heading_5 = 'h5',
  Heading_6 = 'h6',
}

export enum Size {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
}

export enum Variant {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Accent = 'accent',
}

export enum Color {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Accent = 'accent',
  Error = 'error',
  Success = 'success',
}

export enum Weight {
  Thin = 'thin',
  ExtraLight = 'extra_light',
  Light = 'light',
  Regular = 'regular',
  Medium = 'medium',
  SemiBold = 'semi_bold',
  Bold = 'bold',
}
